import React, { Component } from "react";
import {
  Button,
  Form,
  InputGroup,
  FormControl,
  Row,
  Col,
  Card,
  ListGroup,
} from "react-bootstrap";
import sha256 from "sha256";

import { connect } from "react-redux";
import { updateFoot, updateSection } from "../../../../redux/actions/TemplateActions";

import ColorPicker from "../../../../com/lib/plugins/color-picker/ColorPicker";
import {
  createElement,
  createShape,
  createHorizontalLine,
  createQRCode,
  createImageElement,
  companyPath,
  changeProprty,
  changeProprtyM,
  getSectionBoundsPx,
  isFlagOn,
} from "../../../../com/lib/global/helpers";
import { uploadImage } from "../../../../com/lib/api/data/Image";
import SectionImages from "./SectionImages";
import ElementName, { defaultItemName } from "./ElementName";

import { library } from "@fortawesome/fontawesome-svg-core";
import { faLightbulb, faMinus, faQrcode } from "@fortawesome/free-solid-svg-icons";
import { faCircle, faSquare } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

library.add(faLightbulb);

class Foot extends Component {
  constructor(props) {
    super(props);

    this.state = {
      attributes: props.attributes,
      selectedAttributeSection: "",
      selectedAttributePath: "",

      selectedPrimary: "",
      primaryAttributes: [],

      selectedSecondary: "",
      secondaryAttributes: [],
      customText: "",
      qrSourceMode: "generate",
      qrFieldSection: "",
      qrFieldPrimaryAttributes: {},
      qrFieldSelectedPrimary: "",
      qrFieldSecondaryAttributes: [],
      qrFieldSelectedSecondary: "",
      ...this.state,
      localManuallyPositioned: new Set()
    };
    this._selectAttributeSection = this._selectAttributeSection.bind(this);
    this._onCompanyPropChange = this._onCompanyPropChange.bind(this);

    this.props.callbackFromParents(this.props.properties);
  }

  // #region functions

  componentDidMount() {
    //this.props.callbackFromParents(this.props.properties);
  }

  _selectAttributeSection = (key) => {
    var ele = this.state.attributes[key].Properties;
    this.setState({
      selectedAttributeSection: key,
      selectedAttributePath: "",
      primaryAttributes: ele,
      selectedPrimary: "",
      selectedSecondary: "",
      secondaryAttributes: [],
    });
  };

  _onPrimaryAttributeChange = (e) => {
    var index = e.target.selectedIndex;
    var ele = e.target.childNodes[index];
    var key = ele.getAttribute("data-key");

    var dataValue = JSON.parse(e.target.value);
    this.setState(
      {
        selectedPrimary: key,
        selectedSecondary: "",
        selectedAttributePath: "",
      },
      function () {
        if (typeof dataValue == "object") {
          this.setState({ secondaryAttributes: dataValue });
        } else {
          this.setState({ secondaryAttributes: [] }, function () {
            this.setSelectedAttributePath();
          });
        }
      }
    );
  };

  _onSecondaryAttributeChange = (e) => {
    var index = e.target.selectedIndex;
    var ele = e.target.childNodes[index];
    var key = ele.getAttribute("data-key");

    var dataValue = JSON.parse(e.target.value);
    this.setState(
      {
        selectedSecondary: key,
        selectedAttributePath: "",
      },
      function () {
        this.setSelectedAttributePath();
      }
    );
  };

  setSelectedAttributePath = function () {
    var path =
      this.state.selectedAttributeSection + "." + this.state.selectedPrimary;
    path +=
      this.state.selectedSecondary !== ""
        ? "." + this.state.selectedSecondary
        : "";

    this.setState({
      selectedAttributePath: path,
    });
  };

  _addElementtoCanves = (e) => {
    if (this.state.selectedAttributePath !== "") {
      var element = createElement(this.state.selectedAttributePath);
      const { manuallyPositionedElements = new Set() } = this.props;
      const localManuallyPositioned = this.state.localManuallyPositioned || new Set();

      const shouldAutoPosition = !manuallyPositionedElements.has(element.id) &&
        !localManuallyPositioned.has(element.id);

      if (shouldAutoPosition) {
        const elementWidth = 150;
        const elementHeight = 30;

        const position = this._findPositionForNewElement(
          elementWidth,
          elementHeight,
          this._getAllSectionObstacles()
        );

        element.style = {
          ...element.style,
          top: position.top + "px",
          left: position.left + "px"
        };
      }
      var properties = {
        ...this.props.properties,
        elements: {
          ...this.props.properties.elements,
          [element.name.replace(/\./g, "")]: element,
        },
      };

      this.props.updateFoot(properties);
      if (!shouldAutoPosition) {
        this.setState(prevState => ({
          localManuallyPositioned: new Set(prevState.localManuallyPositioned).add(element.id)
        }));
      }
    }
  };

  _addShapetoCanves = (e, shapeName) => {
    if (this.state.selectedAttributePath !== "") {
      var element = shapeName === 'line'
        ? createHorizontalLine(this.state.selectedAttributePath)
        : createShape(this.state.selectedAttributePath);

      const shapeWidth = shapeName === 'line' ? 150 : 32;
      const shapeHeight = shapeName === 'line' ? 2 : 16;
      const position = this._findPositionForNewElement(shapeWidth, shapeHeight, this._getAllSectionObstacles());
      element.style = {
        ...element.style,
        top: position.top + "px",
        left: position.left + "px"
      };

      var shapes = {
        ...this.props.properties,
        shapes: {
          ...this.props.properties.shapes,
          [element.name.replace(/\./g, "")]: element,
        },
      };

      this.props.updateFoot(shapes);

      // if (this.props.onAutoReorganize) {
      //   setTimeout(() => {
      //     this.props.onAutoReorganize();
      //   }, 100);
      // }
    }
  };

  _addQRCodeToCanvas = () => {
    var name = "qr-" + (Object.keys(this.props.properties.qrCodes || {}).length + 1);
    var element = createQRCode(name);

    const position = this._findPositionForNewElement(80, 80, this._getAllSectionObstacles());
    element.style = {
      ...element.style,
      top: position.top + "px",
      left: position.left + "px"
    };

    var updated = {
      ...this.props.properties,
      qrCodes: {
        ...this.props.properties.qrCodes,
        [element.name.replace(/\./g, "")]: element,
      },
    };

    this.props.updateFoot(updated);
  };

  _selectQRFieldSection = (key) => {
    if (!key) {
      this.setState({
        qrFieldSection: "",
        qrFieldPrimaryAttributes: {},
        qrFieldSelectedPrimary: "",
        qrFieldSecondaryAttributes: [],
        qrFieldSelectedSecondary: "",
      });
      return;
    }

    var ele = this.state.attributes[key].Properties;
    this.setState({
      qrFieldSection: key,
      qrFieldPrimaryAttributes: ele,
      qrFieldSelectedPrimary: "",
      qrFieldSecondaryAttributes: [],
      qrFieldSelectedSecondary: "",
    });
  };

  _onQRPrimaryFieldChange = (e) => {
    var index = e.target.selectedIndex;
    var ele = e.target.childNodes[index];
    var key = ele.getAttribute("data-key");
    var dataValue = JSON.parse(e.target.value);

    this.setState({
      qrFieldSelectedPrimary: key,
      qrFieldSelectedSecondary: "",
      qrFieldSecondaryAttributes: typeof dataValue === "object" ? dataValue : [],
    });
  };

  _onQRSecondaryFieldChange = (e) => {
    var index = e.target.selectedIndex;
    var ele = e.target.childNodes[index];
    var key = ele.getAttribute("data-key");

    this.setState({ qrFieldSelectedSecondary: key });
  };

  _getQRFieldPath = () => {
    if (!this.state.qrFieldSection || !this.state.qrFieldSelectedPrimary) return "";

    var path = this.state.qrFieldSection + "." + this.state.qrFieldSelectedPrimary;
    if (this.state.qrFieldSelectedSecondary) {
      path += "." + this.state.qrFieldSelectedSecondary;
    }
    return path;
  };

  _addFieldBoundQRCode = () => {
    const fieldPath = this._getQRFieldPath();
    if (!fieldPath) return;

    var name = "qr-" + (Object.keys(this.props.properties.qrCodes || {}).length + 1);
    var element = createQRCode(name);
    element.qrMode = "field";
    element.qrFieldPath = fieldPath;
    element.qrFieldName = fieldPath.split(".").pop();

    const position = this._findPositionForNewElement(80, 80, this._getAllSectionObstacles());
    element.style = {
      ...element.style,
      top: position.top + "px",
      left: position.left + "px"
    };

    this.props.updateFoot({
      ...this.props.properties,
      qrCodes: {
        ...this.props.properties.qrCodes,
        [element.name.replace(/\./g, "")]: element,
      },
    });

    this.setState({
      qrFieldSection: "",
      qrFieldPrimaryAttributes: {},
      qrFieldSelectedPrimary: "",
      qrFieldSecondaryAttributes: [],
      qrFieldSelectedSecondary: "",
    });
  };

  _handleQRImageUpload = (event) => {
    if (!(event.target.files && event.target.files[0])) return;
    let img = event.target.files[0];

    if (
      img.type !== "image/png" &&
      img.type !== "image/jpeg" &&
      img.type !== "image/jpg"
    ) {
      alert(`${img.name} is not an image file`);
      return;
    }

    var name = "qr-" + (Object.keys(this.props.properties.qrCodes || {}).length + 1);
    var element = createQRCode(name);
    var key = element.name.replace(/\./g, "");
    element.qrMode = "image";
    element.qrImage = URL.createObjectURL(img);

    const position = this._findPositionForNewElement(80, 80, this._getAllSectionObstacles());
    element.style = {
      ...element.style,
      top: position.top + "px",
      left: position.left + "px"
    };

    this.props.updateFoot({
      ...this.props.properties,
      qrCodes: {
        ...this.props.properties.qrCodes,
        [key]: element,
      },
    });

    uploadImage(img).then((result) => {
      if (result.data && result.status === 200) {
        const current = this.props.properties.qrCodes?.[key];
        if (!current) return;

        this.props.updateFoot({
          ...this.props.properties,
          qrCodes: {
            ...this.props.properties.qrCodes,
            [key]: { ...current, qrImage: result.data.Result },
          },
        });
      }
    });

    event.target.value = "";
  };

  // Definitions offered for fields (and QR codes): every object definition,
  // company fields included, in the footer and in sections added by the user.
  _isListedDefinition = (key, { forQR = false } = {}) => {
    const attribute = this.state.attributes[key];
    if (!attribute || attribute.DataType === "List" || key === "EposTemplateSettingsDefinition") return false;
    if (forQR && key === "EPOSCompanyBankDefinition") return false;
    return true;
  };

  _getSectionBoundsPx = () => {
    // In bands mode the editor passes the band's own size.
    if (this.props.bandBounds) return this.props.bandBounds;
    const bounds = this.props.pageProp && this.props.heights
      ? getSectionBoundsPx(this.props.pageProp, this.props.heights, "foot")
      : null;

    return {
      width: bounds ? bounds.width : 800,
      height: bounds ? bounds.height : 400,
    };
  };

  _getAllSectionObstacles = () => {
    const obstacles = [];
    const props = this.props.properties;

    const push = (el, defaultWidth, defaultHeight) => {
      if (!el || !el.style) return;
      obstacles.push({
        id: el.id,
        style: {
          top: el.style.top,
          left: el.style.left,
          width: el.style.width || (defaultWidth + "px"),
          height: el.style.height || (defaultHeight + "px"),
        }
      });
    };

    if (props.elements) {
      Object.values(props.elements).forEach(el => push(el, 150, 30));
    }
    if (props.shapes) {
      Object.keys(props.shapes).filter(k => k !== "border").forEach(key => {
        const shape = props.shapes[key];
        const isLine = shape.name && shape.name.startsWith("line");
        push(shape, isLine ? 150 : 32, isLine ? 2 : 16);
      });
    }
    if (props.qrCodes) {
      Object.values(props.qrCodes).forEach(el => push(el, 80, 80));
    }
    if (props.images) {
      Object.values(props.images).forEach(el => push(el, 150, 150));
    }

    return obstacles;
  };

  _findPositionForNewElement = (width, height, existingElements) => {
    const GRID_SIZE = 10;
    const START_X = 40;
    const START_Y = 40;
    const bounds = this._getSectionBoundsPx();
    const MAX_X = bounds.width;
    const MAX_Y = bounds.height;
    const MARGIN = 10;

    for (let y = START_Y; y <= MAX_Y - height; y += GRID_SIZE) {
      for (let x = START_X; x <= MAX_X - width; x += GRID_SIZE) {
        let positionValid = true;

        const testRect = {
          top: y,
          left: x,
          right: x + width,
          bottom: y + height
        };

        for (const element of existingElements) {
          if (!element.style) continue;

          const elementTop = parseInt(element.style.top) || 0;
          const elementLeft = parseInt(element.style.left) || 0;
          const elementWidth = parseInt(element.style.width) || 150;
          const elementHeight = parseInt(element.style.height) || 30;

          const elementRect = {
            top: elementTop,
            left: elementLeft,
            right: elementLeft + elementWidth,
            bottom: elementTop + elementHeight
          };

          if (this._rectanglesOverlap(testRect, elementRect, MARGIN)) {
            positionValid = false;
            break;
          }
        }

        if (positionValid) {
          return { top: y, left: x };
        }
      }
    }

    const occupiedPositions = [];

    for (const element of existingElements) {
      if (!element.style) continue;

      const elementTop = parseInt(element.style.top) || 0;
      const elementLeft = parseInt(element.style.left) || 0;
      const elementWidth = parseInt(element.style.width) || 150;
      const elementHeight = parseInt(element.style.height) || 30;

      occupiedPositions.push({
        top: elementTop,
        left: elementLeft,
        right: elementLeft + elementWidth,
        bottom: elementTop + elementHeight
      });
    }

    let testY = START_Y;
    let testX = START_X;
    let maxAttempts = 100;
    let attempts = 0;

    while (attempts < maxAttempts) {
      let foundSpace = true;
      const testRect = {
        top: testY,
        left: testX,
        right: testX + width,
        bottom: testY + height
      };

      for (const occupied of occupiedPositions) {
        if (this._rectanglesOverlap(testRect, occupied, MARGIN)) {
          foundSpace = false;
          testX = occupied.right + MARGIN;

          if (testX + width > MAX_X) {
            testX = START_X;
            testY += height + MARGIN;
          }
          break;
        }
      }

      if (foundSpace && testY + height <= MAX_Y && testX + width <= MAX_X) {
        return { top: testY, left: testX };
      }

      attempts++;
    }

    return { top: START_Y, left: START_X };
  };

  _rectanglesOverlap = (rect1, rect2, margin = 0) => {
    return !(
      rect1.right + margin < rect2.left ||
      rect2.right + margin < rect1.left ||
      rect1.bottom + margin < rect2.top ||
      rect2.bottom + margin < rect1.top
    );
  };

  _handleTextChange = (e, data, elementKey) => {
    const newText = e.target.value;
    let finalText = newText;

    if (data.data !== "customText" && !data.name.includes("Custom-Text-")) {
      finalText = newText.replace(/\n/g, ' ');
    }

    const updatedElement = {
      ...data,
      text: finalText
    };

    const updatedElements = {
      ...this.props.properties.elements
    };

    updatedElements[elementKey] = updatedElement;

    var props = {
      ...this.props.properties,
      elements: updatedElements
    };

    this.props.updateFoot(props);
  }


  _renderElementList = (section) => {
    var index = 0;
    return Object.keys(this.props.properties.elements).map((key) => {
      var data = this.props.properties.elements[key];
      index++;
      var id = sha256(section + "-ele-" + index);

      var isSelected = false;
      const elementKey = key;
      const isCustomText = data.name.includes("Custom-Text-") || data.data === "customText";
      return (
        <ListGroup.Item
          className={
            "d-flex justify-content-between lh-condensed" +
            (isSelected ? " bg-primary text-white" : " bg-white")
          }
          data-target={data.id}
          data-section={this.props.sectionKey || "foot"}
          data-path={"elements"}
          data-index={elementKey}
          key={elementKey}
          onClick={(e) => this.props.onElementSelected(data.id)}
        >
          <div>
            <h6 className="my-0 tmplate-multiline-text" title={"{" + data.text + "}"}>
              {data.name}
            </h6>
            <small
              className="text-muted"
              style={{
                display: "block",
                width: "240px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
              title={"{" + data.name + "}"}
              onClick={(e) => e.stopPropagation()}
            >
              {isCustomText ? (
                <textarea
                  rows={3}
                  style={{
                    width: "100%",
                    resize: "vertical",
                    overflow: "hidden"
                  }}
                  onChange={(e) => this._handleTextChange(e, data, elementKey)}
                  value={data.text || ''}
                  onKeyDown={(e) => {
                    if (!isCustomText && e.key === 'Enter') {
                      e.preventDefault();
                      e.stopPropagation();
                    }
                  }}
                  onClick={(e) => e.stopPropagation()}
                  onFocus={(e) => e.stopPropagation()}
                />
              ) : (
                <input
                  type="text"
                  style={{
                    width: "100%",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis"
                  }}
                  onChange={(e) => this._handleTextChange(e, data, elementKey)}
                  value={data.text || ''}
                  onKeyDown={(e) => {
                    if (!isCustomText && e.key === 'Enter') {
                      e.preventDefault();
                      e.stopPropagation();
                    }
                  }}
                  onClick={(e) => e.stopPropagation()}
                  onFocus={(e) => e.stopPropagation()}
                />
              )}

            </small>
          </div>
          <span className="text-muted">
            <Button variant="link" onClick={(e) => {
              e.stopPropagation();
              this._handleRemoveElement(data, elementKey);
            }}>
              <FontAwesomeIcon icon="minus" />
            </Button>
          </span>
        </ListGroup.Item>
      );
    });
  };

  _renderShapesList = (section) => {
    var index = 0;

    return Object.keys(this.props.properties.shapes).filter(s => s !== 'border').map((key) => {
      var data = this.props.properties.shapes[key];
      index++;
      var id = sha256(section + "-ele-" + index);

      var isSelected = false;
      const elementKey = key;
      return (
        <ListGroup.Item
          className={
            "d-flex justify-content-between lh-condensed" +
            (isSelected ? " bg-primary text-white" : " bg-white")
          }
          data-target={data.id}
          data-section={this.props.sectionKey || "foot"}
          data-path={"shapes"}
          data-index={elementKey}
          key={key}
          onClick={(e) => this.props.onElementSelected(data.id)}
        >
          <div>
            <h6 className="my-0 tmplate-multiline-text">
              <ElementName label={data.label} fallback={defaultItemName("shapes", key)} onRename={(label) => this._renameItem("shapes", key, label)} />
            </h6>
          </div>
          <span className="text-muted">
            <Button variant="link" onClick={(e) => {
              e.stopPropagation();
              this._handleRemoveShape(data, elementKey);
            }}>
              <FontAwesomeIcon icon="minus" />
            </Button>
          </span>
        </ListGroup.Item>
      );
    });
  };


  _handleRemoveElement = (data, elementKey) => {
    const updatedElements = { ...this.props.properties.elements };
    delete updatedElements[elementKey];

    var props = {
      ...this.props.properties,
      elements: updatedElements
    };

    this.props.updateFoot(props);
  }

  // A shape's or QR code's own name (`label`); undefined goes back to the
  // default name.
  _renameItem = (path, key, label) => {
    const item = this.props.properties[path]?.[key];
    if (!item) return;
    const next = { ...item };
    if (label) next.label = label;
    else delete next.label;
    this.props.updateFoot({ ...this.props.properties, [path]: { ...this.props.properties[path], [key]: next } });
  };

  _handleRemoveShape = (data, elementKey) => {
    const updatedShapes = { ...this.props.properties.shapes };
    delete updatedShapes[elementKey];

    var props = {
      ...this.props.properties,
      shapes: updatedShapes
    };
    this.props.updateFoot(props);
  }

  _renderQRCodesList = () => {
    if (!this.props.properties.qrCodes) return null;

    return Object.keys(this.props.properties.qrCodes).map((key) => {
      var data = this.props.properties.qrCodes[key];
      var isSelected = false;
      const elementKey = key;

      return (
        <ListGroup.Item
          className={
            "d-flex justify-content-between lh-condensed" +
            (isSelected ? " bg-primary text-white" : " bg-white")
          }
          data-target={data.id}
          data-section={this.props.sectionKey || "foot"}
          data-path={"qrCodes"}
          data-index={elementKey}
          key={key}
          onClick={(e) => this.props.onElementSelected(data.id)}
        >
          <div>
            <h6 className="my-0 tmplate-multiline-text">
              <ElementName label={data.label} fallback={defaultItemName("qrCodes", key)} onRename={(label) => this._renameItem("qrCodes", key, label)} />
            </h6>
          </div>
          <span className="text-muted">
            <Button variant="link" onClick={(e) => {
              e.stopPropagation();
              this._handleRemoveQRCode(data, elementKey);
            }}>
              <FontAwesomeIcon icon="minus" />
            </Button>
          </span>
        </ListGroup.Item>
      );
    });
  };

  _handleRemoveQRCode = (data, elementKey) => {
    const updatedQRCodes = { ...this.props.properties.qrCodes };
    delete updatedQRCodes[elementKey];

    var props = {
      ...this.props.properties,
      qrCodes: updatedQRCodes
    };
    this.props.updateFoot(props);
  }

  _handleChangeDateFormat = (data, e) => {
    let templmntselemnets = { ...this.props.properties.elements }
    let uptadedVal = Object.assign(
      this.props.properties.elements[data.name.split('.').join('')],
      { dateFormat: e.target.value }
    )

    var props = {
      ...this.props.properties,
      elements: Object.assign(templmntselemnets, { [data.name.split('.').join('')]: uptadedVal })
    };
    this.props.updateFoot(props);
  }

  _onImageSelect = (event) => {
    if (event.target.files && event.target.files[0]) {
      let img = event.target.files[0];
      if (
        img.type !== "image/png" &&
        img.type !== "image/jpeg" &&
        img.type !== "image/jpg"
      ) {
        alert(`${img.name} is not an image file`);
        return false;
      }

      uploadImage(img).then((result) => {
        console.log("upload result===>>", result)
        var path = companyPath();
        var element = createImageElement(path + ".CompanyLogo");
        element.logo = result.data.Result;
        element.showLogo = this.props.properties.logo.showLogo;

        var props = {
          ...this.props.properties,
          logo: element,
        };
        this.props.updateFoot(props);
      });
    }
  };

  _onCompanyPropChange = (e, key) => {
    var chk = e.target.checked;
    var props = {
      ...this.props.properties,
      companyProps: {
        ...this.props.properties.companyProps,
        [key]: {
          ...this.props.properties.companyProps[key],
          show: chk,
        },
      },
    };
    this.props.updateFoot(props);
  };
  // #endregion
  _addCustomTextElement = (e) => {
    const text = this.textareaRef ? this.textareaRef.value : "";
    if (text && text.trim()) {
      const elements = this.props.properties?.elements || {};

      const existingIndexes = Object.keys(elements)
        .filter((key) => key.startsWith("Custom-Text-"))
        .map((key) => parseInt(key.replace("Custom-Text-", ""), 10))
        .filter((num) => !isNaN(num));

      const nextIndex =
        existingIndexes.length > 0 ? Math.max(...existingIndexes) + 1 : 1;

      const elementName = `Custom-Text-${nextIndex}`;
      const cleanElementName = elementName.replace(/[^a-zA-Z0-9-]/g, '');

      var element = {
        name: cleanElementName,
        text: text,
        data: "customText",
        id: sha256(elementName + "-ele-" + Date.now()),
        style: {
          position: "absolute",
          top: "40px",
          left: "40px",
          zIndex: 1,
          whiteSpace: "pre-line"
        },
      };

      const { manuallyPositionedElements = new Set() } = this.props;
      const localManuallyPositioned = this.state.localManuallyPositioned || new Set();

      const shouldAutoPosition = !manuallyPositionedElements.has(element.id) &&
        !localManuallyPositioned.has(element.id);

      if (shouldAutoPosition) {
        const lineHeight = 16;
        const lineCount = text.split('\n').length;
        const elementHeight = Math.max(30, lineCount * lineHeight + 10);
        const elementWidth = 150;

        const position = this._findPositionForNewElement(
          elementWidth,
          elementHeight,
          this._getAllSectionObstacles()
        );

        element.style = {
          ...element.style,
          top: position.top + "px",
          left: position.left + "px",
          // No height: the box fits its lines and grows with them.
          width: elementWidth + "px"
        };
      }

      var properties = {
        ...this.props.properties,
        elements: {
          ...this.props.properties.elements,
          [cleanElementName]: element,
        },
      };

      this.props.updateFoot(properties);

      if (this.textareaRef) {
        this.textareaRef.value = "";
      }
      this.setState({ customText: "" });

      if (!shouldAutoPosition) {
        this.setState(prevState => ({
          localManuallyPositioned: new Set(prevState.localManuallyPositioned).add(element.id)
        }));
      }
    }
  };
  render() {
    return (
      <>
        <div className="column-header">
          <span
            className="font-large"
            title={`${this.props.panelTitle || "Footer"} Properties`}
            style={{ maxWidth: "200px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", verticalAlign: "middle" }}
          >
            {this.props.panelTitle || "Footer"} Properties
          </span>
          <Button
            variant="link ml-2"
            className="text-dark text-decoration-none"
            onClick={(e) => {
              this.props.showToolTips(true);
            }}
          >
            <FontAwesomeIcon icon="lightbulb" className="me-2" />
            Tool Tips
          </Button>
        </div>
        <div className="column-body">
          {/* Section settings (where it prints, height, …), passed in by the editor. */}
          {this.props.sectionSettings}
          {/* Tools the editor adds to every section, e.g. current date & time. */}
          {this.props.extraTools}
          {typeof this.props.properties !== "undefined" ? (
            <Form>
              {/* In bands mode the band's own settings say where it prints. */}
              <Row className={this.props.bandsMode ? "d-none" : ""}>
                <Col sm={12}>
                  <Form.Group controlId="forPrintHeaderEveryPage">
                    <Form.Check
                      type="checkbox"
                      label="Print Footer Every Page"
                      className="fw-bold"
                      checked={
                        isFlagOn(this.props.properties?.printingFooterEveryPage)
                      }
                      onChange={(e) =>
                        changeProprty(
                          "printingFooterEveryPage",
                          e.target.checked,
                          this.props,
                          this.props.updateFoot
                        )
                      }
                    />
                  </Form.Group>
                  <hr />
                </Col>
              </Row>


              <Row>
                <Col sm={6}>
                  <Form.Group>
                    <Form.Label>Background Colour</Form.Label>
                    <InputGroup style={{ position: "inherit" }}>
                      {/* <FormControl
                        value={this.props.properties.background.color}
                        readOnly
                      /> */}
                      <InputGroup.Append>
                        <ColorPicker
                          {...this.props}
                          color={this.props.properties.background.color}
                          callbackFromParents={(e) => {
                            changeProprtyM(
                              "background.color",
                              e.hex,
                              this.props,
                              this.props.updateFoot
                            );
                          }}
                        />
                      </InputGroup.Append>
                    </InputGroup>
                  </Form.Group>
                </Col>
                <Col sm={12}>
                  <Form.Group controlId="forBackgroundColorFoot">
                    <Form.Check
                      type="checkbox"
                      label="Show Background Color"
                      checked={
                        this.props.properties &&
                        this.props.properties.background.showColor
                      }
                      onChange={(e) =>
                        changeProprtyM(
                          "background.showColor",
                          e.target.checked,
                          this.props,
                          this.props.updateFoot
                        )
                      }
                    />
                  </Form.Group>
                </Col>
              </Row>

              <hr />

              <Row>
                <Col>
                  <div className="fw-bold mt-3">
                    Draw Shape
                  </div>
                  <div>
                    <Button variant="light border"
                      onClick={(e) => {
                        // this._addShapetoCanves(e, 'box')
                        this.setState(
                          {
                            selectedAttributePath:
                              "box-" +
                              parseInt(
                                Object.keys(this.props.properties.shapes)
                                  .length + 1
                              ),
                          },
                          function () {
                            this._addShapetoCanves(e, 'box')
                          }
                        );
                      }}
                    >
                      <FontAwesomeIcon icon={faSquare} size="1x" />
                    </Button>

                    &nbsp;&nbsp;
                    <Button variant="light border"
                      onClick={(e) => {
                        // this._addShapetoCanves(e, 'circle');
                        this.setState(
                          {
                            selectedAttributePath:
                              "circle-" +
                              parseInt(
                                Object.keys(this.props.properties.shapes)
                                  .length + 1
                              ),
                          },
                          function () {
                            this._addShapetoCanves(e, 'circle');
                          }
                        );
                      }}>
                      <FontAwesomeIcon icon={faCircle} size="1x" />
                    </Button>

                    &nbsp;&nbsp;
                    <Button variant="light border"
                      onClick={(e) => {
                        this.setState(
                          {
                            selectedAttributePath:
                              "line-" +
                              parseInt(
                                Object.keys(this.props.properties.shapes)
                                  .length + 1
                              ),
                          },
                          function () {
                            this._addShapetoCanves(e, 'line');
                          }
                        );
                      }}>
                      <FontAwesomeIcon icon={faMinus} size="1x" />
                    </Button>

                  </div>
                </Col>
              </Row>
              <hr />
              <SectionImages
                section={this.props.sectionKey || "foot"}
                properties={this.props.properties}
                onUpdate={this.props.updateFoot}
                findPosition={(width, height) => this._findPositionForNewElement(width, height, this._getAllSectionObstacles())}
                onElementSelected={this.props.onElementSelected}
              />
              <hr />
              <Row>
                <Col>
                  <div className="fw-bold mt-3">
                    QR Code
                  </div>
                  <div className="mb-2">
                    <Form.Check
                      inline
                      type="radio"
                      name="foot-qr-source-mode"
                      id="foot-qr-mode-generate"
                      label="Generate from text"
                      checked={this.state.qrSourceMode === "generate"}
                      onChange={() => this.setState({ qrSourceMode: "generate" })}
                    />
                    <Form.Check
                      inline
                      type="radio"
                      name="foot-qr-source-mode"
                      id="foot-qr-mode-image"
                      label="Upload image"
                      checked={this.state.qrSourceMode === "image"}
                      onChange={() => this.setState({ qrSourceMode: "image" })}
                    />
                    <Form.Check
                      inline
                      type="radio"
                      name="foot-qr-source-mode"
                      id="foot-qr-mode-field"
                      label="Bind to field"
                      checked={this.state.qrSourceMode === "field"}
                      onChange={() => this.setState({ qrSourceMode: "field" })}
                    />
                  </div>
                  <div>
                    {this.state.qrSourceMode === "image" ? (
                      <Form.Control
                        type="file"
                        size="sm"
                        accept="image/png, image/jpeg, image/jpg"
                        onChange={(e) => this._handleQRImageUpload(e)}
                      />
                    ) : this.state.qrSourceMode === "field" ? (
                      <>
                        <select
                          className="form-select form-select-sm mb-2"
                          value={this.state.qrFieldSection}
                          onChange={(e) => this._selectQRFieldSection(e.target.value)}
                        >
                          <option value="">Select field group</option>
                          {Object.keys(this.state.attributes)
                            .filter((key) => this._isListedDefinition(key, { forQR: true }))
                            .map((key) => (
                              <option key={key} value={key}>{key}</option>
                            ))}
                        </select>

                        {this.state.qrFieldSection && (
                          <select
                            className="form-select form-select-sm mb-2"
                            onChange={(e) => this._onQRPrimaryFieldChange(e)}
                          >
                            <option>Select field</option>
                            {Object.keys(this.state.qrFieldPrimaryAttributes).map((key) => {
                              var value = this.state.qrFieldPrimaryAttributes[key];
                              return (
                                <option key={key} value={JSON.stringify(value)} data-key={key}>
                                  {key}
                                </option>
                              );
                            })}
                          </select>
                        )}

                        {Object.keys(this.state.qrFieldSecondaryAttributes).length > 0 && (
                          <select
                            className="form-select form-select-sm mb-2"
                            onChange={(e) => this._onQRSecondaryFieldChange(e)}
                          >
                            <option>Select field</option>
                            {Object.keys(this.state.qrFieldSecondaryAttributes).map((key) => {
                              var value = this.state.qrFieldSecondaryAttributes[key];
                              return (
                                <option key={key} value={JSON.stringify(value)} data-key={key}>
                                  {key}
                                </option>
                              );
                            })}
                          </select>
                        )}

                        <Button variant="light border"
                          disabled={!this._getQRFieldPath()}
                          onClick={() => this._addFieldBoundQRCode()}>
                          <FontAwesomeIcon icon={faQrcode} size="1x" />
                        </Button>
                      </>
                    ) : (
                      <Button variant="light border"
                        onClick={() => this._addQRCodeToCanvas()}>
                        <FontAwesomeIcon icon={faQrcode} size="1x" />
                      </Button>
                    )}
                  </div>
                </Col>
              </Row>
              <br />

              <Row>
                <Col sm={6}>
                  <Form.Group>
                    <Form.Label for="titleColor">Border Colour</Form.Label>
                    <InputGroup>
                      {/* <FormControl
                        value={this.props.properties?.shapes?.border?.color || '#333333FF'}
                      /> */}
                      <InputGroup.Append>
                        <ColorPicker
                          {...this.props}
                          id="borderColor"
                          name="borderColor"
                          color={
                            this.props.properties?.shapes?.border?.color || '#333333FF'
                          }
                          callbackFromParents={(e) => {
                            changeProprtyM(
                              "shapes.border.color",
                              e.hex,
                              this.props,
                              this.props.updateFoot
                            );
                          }}
                        />
                      </InputGroup.Append>
                    </InputGroup>
                  </Form.Group>
                </Col>
                <Col sm={6}>
                  <Form.Group controlId="forTitleFontSize">
                    <Form.Label>Border</Form.Label>
                    <InputGroup>
                      <FormControl
                        value={
                          this.props.properties?.shapes?.border?.size || 1
                        }
                        onChange={(e) => {
                          changeProprtyM(
                            "shapes.border.size",
                            Number(e.target.value),
                            this.props,
                            this.props.updateFoot
                          )
                        }
                        }
                        type="number"
                      />
                      <InputGroup.Text>px</InputGroup.Text>
                    </InputGroup>
                  </Form.Group>
                </Col>
                <Col sm={6}>
                  <Form.Group>
                    <Form.Label for="titleColor">Fill Colour</Form.Label>
                    <InputGroup>
                      {/* <FormControl
                        value={this.props.properties?.shapes?.border?.fillColor || '#333333FF'}
                      /> */}
                      <InputGroup.Append>
                        <ColorPicker
                          {...this.props}
                          id="fillColor"
                          name="fillColor"
                          color={
                            this.props.properties?.shapes?.border?.fillColor || '#333333FF'
                          }
                          callbackFromParents={(e) => {
                            changeProprtyM(
                              "shapes.border.fillColor",
                              e.hex,
                              this.props,
                              this.props.updateFoot
                            );
                          }}
                        />
                      </InputGroup.Append>
                    </InputGroup>
                  </Form.Group>
                </Col>
              </Row>

              < hr />
              <Row>
                <Col sm={6}>
                  <Form.Group>
                    <Form.Label>Font </Form.Label>
                    <select
                      className="form-select form-control"
                      aria-label="Default select"
                      onChange={(e) =>
                        changeProprtyM(
                          "font.fontFamily",
                          e.target.value,
                          this.props,
                          this.props.updateFoot
                        )
                      }
                      value={
                        this.props.properties?.font?.fontFamily || 'Inter'
                      }
                    >
                      <option value="Inter">Inter</option>
                      <option value="Times New Roman">Times New Roman</option>
                      <option value="Lato">Lato</option>
                      <option value="Montserrat">Montserrat</option>
                      <option value="Open Sans">Open Sans</option>
                      <option value="Roboto">Roboto</option>
                      <option value="Arimo">Arimo</option>
                    </select>
                  </Form.Group>
                </Col>

                <Col sm={6}>
                  <Form.Group controlId="forFontSize">
                    <Form.Label>Font Size</Form.Label>
                    <InputGroup>
                      <FormControl
                        value={
                          this.props.properties?.font?.fontSize || 10
                        }
                        onChange={(e) => {
                          changeProprtyM(
                            "font.fontSize",
                            Number(e.target.value),
                            this.props,
                            this.props.updateFoot
                          )
                        }
                        }
                        type="number"
                      />
                      <InputGroup.Text>pt</InputGroup.Text>
                    </InputGroup>
                  </Form.Group>
                </Col>
                <Col sm={6}>
                  <Form.Group>
                    <Form.Label>Colour</Form.Label>
                    <InputGroup>
                      {/* <FormControl
                        value={this.props.properties?.font?.color || '#000000FF'}
                        readOnly
                      /> */}
                      <InputGroup.Append>
                        <ColorPicker
                          {...this.props}
                          color={this.props.properties?.font?.color || '#000000FF'}
                          callbackFromParents={(e) => {
                            changeProprtyM(
                              "font.color",
                              e.hex,
                              this.props,
                              this.props.updateFoot
                            );
                          }}
                        />
                      </InputGroup.Append>
                    </InputGroup>
                  </Form.Group>
                </Col>

              </Row>
              < hr />

              <Row>
                <Col>
                  <Form.Group>
                    <Form.Label className="fw-bold mt-3">
                      Add new Element
                    </Form.Label>
                    <InputGroup>
                      <FormControl
                        as="textarea"
                        rows={3}
                        placeholder="Enter multi-line text..."
                        ref={(textarea) => (this.textareaRef = textarea)}
                        style={{ resize: "vertical" }}
                      />
                      <InputGroup.Append>
                        <Button
                          variant="light border"
                          title="Add new text"
                          onClick={(e) => {
                            const text = this.textareaRef ? this.textareaRef.value : "";
                            if (text.trim()) {
                              this.setState(
                                {
                                  selectedAttributePath: "MultiLine-Text-" +
                                    parseInt(
                                      Object.keys(this.props.properties.elements).length + 1
                                    ),
                                  customText: text
                                },
                                () => {
                                  this._addCustomTextElement(e);
                                  if (this.textareaRef) {
                                    this.textareaRef.value = "";
                                  }
                                }
                              );
                            }
                          }}
                          style={{ cursor: "pointer", height: "100%" }}
                        >
                          <i
                            className="bi bi-fonts"
                            style={{ fontSize: "1.3rem" }}
                          ></i>
                        </Button>
                      </InputGroup.Append>
                    </InputGroup>
                    <small className="text-muted">Enter text and click the button to add it as a multi-line element.</small>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col>
                  <Form.Group>
                    <Form.Label className="fw-bold mt-3">
                      Additional Properties
                    </Form.Label>
                    <ListGroup className="mb-3">
                      {Object.keys(this.state.attributes).map((key) => {
                        if (this._isListedDefinition(key)) {
                          return (
                            <ListGroup.Item
                              key={key}
                              className={
                                "d-flex justify-content-between lh-condensed " +
                                (this.state.selectedAttributeSection === key
                                  ? "bg-primary text-white"
                                  : "bg-white")
                              }
                              onClick={(e) => this._selectAttributeSection(key)}
                              style={{ cursor: "pointer" }}
                            >
                              <div>
                                <h6 className="my-0 tmplate-multiline-text">{key}</h6>
                                <small
                                  className={
                                    "small " +
                                    (this.state.selectedAttributeSection === key
                                      ? "bg-primary text-white"
                                      : "bg-white")
                                  }
                                >
                                  {Object.keys(
                                    this.state.attributes[key].Properties
                                  ).length + " inherited properties"}
                                </small>
                              </div>
                            </ListGroup.Item>
                          );
                        }
                      })}
                    </ListGroup>
                  </Form.Group>

                  {Object.keys(this.state.primaryAttributes).length > 0 ? (
                    <Form.Group>
                      <Form.Label className="fw-bold mt-3">
                        Custom Attribute
                      </Form.Label>
                      <InputGroup>
                        <select
                          className="form-select form-control"
                          aria-label="Default select"
                          onChange={(e) => {
                            this._onPrimaryAttributeChange(e);
                          }}
                        >
                          <option>Select attribute</option>
                          {Object.keys(this.state.primaryAttributes)
                            // Company logos are images (Header > logo), not text fields.
                            .filter((key) => !(this.state.selectedAttributeSection === companyPath() && key.includes("Logo")))
                            .map(
                            (key) => {
                              var value = this.state.primaryAttributes[key];
                              return (
                                <option
                                  key={key}
                                  value={JSON.stringify(value)}
                                  data-key={key}
                                >
                                  {key}
                                </option>
                              );
                            }
                          )}
                        </select>
                        {Object.keys(this.state.secondaryAttributes).length ==
                          0 ? (
                          <InputGroup.Text>
                            <Button
                              variant="link"
                              onClick={(e) => {
                                this._addElementtoCanves(e);
                              }}
                            >
                              <FontAwesomeIcon icon="plus" />
                            </Button>
                          </InputGroup.Text>
                        ) : (
                          <></>
                        )}
                      </InputGroup>
                    </Form.Group>
                  ) : (
                    <></>
                  )}

                  {Object.keys(this.state.secondaryAttributes).length > 0 ? (
                    <Form.Group>
                      <Form.Label className="fw-bold mt-3">
                        Inherited Attribute
                      </Form.Label>
                      <InputGroup>
                        <select
                          className="form-select form-control"
                          aria-label="Default select"
                          onChange={(e) => {
                            this._onSecondaryAttributeChange(e);
                          }}
                        >
                          <option>Select attribute</option>
                          {Object.keys(this.state.secondaryAttributes).map(
                            (key) => {
                              var value = this.state.secondaryAttributes[key];
                              return (
                                <option
                                  key={key}
                                  value={JSON.stringify(value)}
                                  data-key={key}
                                >
                                  {key}
                                </option>
                              );
                            }
                          )}
                        </select>
                        <InputGroup.Text>
                          <Button
                            variant="link"
                            onClick={(e) => {
                              this._addElementtoCanves(e);
                            }}
                          >
                            <FontAwesomeIcon icon="plus" />
                          </Button>
                        </InputGroup.Text>
                      </InputGroup>
                    </Form.Group>
                  ) : (
                    <></>
                  )}

                  <ListGroup
                    className="mb-3 border-1"
                    style={{
                      maxHeight: "300px",
                      overflowX: "none",
                      overflowY: "scroll",
                      overflowX: "hidden",
                    }}
                  >
                    {this._renderElementList()}
                  </ListGroup>
                </Col>
              </Row>

              <hr />

              <Row>
                <Col>
                  <Form.Group>
                    <Form.Label className="fw-bold mt-3">
                      Shapes
                    </Form.Label>
                  </Form.Group>

                  <ListGroup
                    className="mb-3 border-1"
                    style={{
                      maxHeight: "300px",
                      overflowX: "none",
                      overflowY: "scroll",
                      overflowX: "hidden",
                    }}
                  >
                    {this._renderShapesList()}
                  </ListGroup>
                </Col>
              </Row>

              <hr />

              <Row>
                <Col>
                  <Form.Group>
                    <Form.Label className="fw-bold mt-3">
                      QR Codes
                    </Form.Label>
                  </Form.Group>

                  <ListGroup
                    className="mb-3 border-1"
                    style={{
                      maxHeight: "300px",
                      overflowX: "none",
                      overflowY: "scroll",
                      overflowX: "hidden",
                    }}
                  >
                    {this._renderQRCodesList()}
                  </ListGroup>
                </Col>
              </Row>
              {/* <Button
                variant="primary"
                className="mb-3"
                onClick={() => {
                  if (this.props.onAutoReorganize) {
                    this.props.onAutoReorganize();
                  }
                }}
                title="Auto-Rearrange Elements"
                style={{ position: 'absolute', bottom: '60px', left: '280px', zIndex: 1000, boxShadow: '0 4px 8px rgba(0.5, 0.5, 0.5, 0.5)', width: '40px', height: '40px' }}
              >
                <FontAwesomeIcon icon="magic" />
              </Button> */}
            </Form>
          ) : (
            <></>
          )}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    properties: state.template.foot,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateFoot: (e) => dispatch(updateFoot(e)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Foot);

// The same panel for any added band in bands mode: reads and writes the
// content stored under the band's own key (`sectionKey`).
export const BandContentPanel = connect(
  (state, ownProps) => ({ properties: state.template[ownProps.sectionKey] }),
  (dispatch, ownProps) => ({ updateFoot: (e) => dispatch(updateSection(ownProps.sectionKey, e)) })
)(Foot);
